import { OryxGameClient } from "@westpierstudio/core-module-oryx/game";
import { RequestMessage } from "@westpierstudio/core-module-oryx/services/comms/types/BaseTypes";
import { PeriodicInspectionEvent } from "@westpierstudio/core-module-oryx/services/comms/types/PeriodicInspection";
import { GameEventRequestMessage } from "@westpierstudio/core-module-oryx/services/comms/types/Requests";
import { AuthenticateResponseMessage } from "@westpierstudio/core-module-oryx/services/comms/types/Responses";
import { GameEvent, GameRequest } from "servertypes/ServerEvents";
import { OpenGameEvent } from "servertypes/gameevents/OpenGame";
import { InitialSpinEvent } from "servertypes/gameevents/InitialSpin";
import { FreeSpinEvent } from "servertypes/gameevents/FreeSpin";
import { SpinErrorEvent } from "servertypes/gameevents/SpinError";
import { Signal } from "type-signals";
import { GenericGameRequestMessage } from "servertypes/GameRequests";
import { BetData } from "servertypes/SharedTypes";

class PrinceOfThievesGameClientSignals {
    openGame = new Signal<(event: OpenGameEvent) => void>();
    initialSpin = new Signal<(event: InitialSpinEvent) => void>();
    freeSpin = new Signal<(event: FreeSpinEvent) => void>();
    spinError = new Signal<(event: SpinErrorEvent) => void>();
    periodicInspection = new Signal<(event: PeriodicInspectionEvent) => void>();
    activateFreeRoundError = new Signal<(code: number) => void>();
}

export class PrinceOfThievesGameClient extends OryxGameClient {
    signals = new PrinceOfThievesGameClientSignals();

    handleIncomingGameEvent(gameEvent: GameEventRequestMessage, _triggeringRequest: RequestMessage): void {

        switch (gameEvent.body.event as GameEvent) {
            case GameEvent.OPEN_GAME:
                this.signals.openGame.dispatch(gameEvent);
                break;
            case GameEvent.INITIAL_SPIN:
                this.signals.initialSpin.dispatch(gameEvent);
                break;
            case GameEvent.FREE_SPIN:
                this.signals.freeSpin.dispatch(gameEvent);
                break;
            case GameEvent.SPIN_ERROR:
                this.signals.spinError.dispatch(gameEvent);
                break;
            default:
                this.missingHandlerWarning(gameEvent.header.name);
        }
    }

    handlePeriodicInspectionEvent(periodicInspection: PeriodicInspectionEvent): void {
        this.signals.periodicInspection.dispatch(periodicInspection);
    }

    override handleAuthenticate(response: AuthenticateResponseMessage, triggeringRequest: RequestMessage) {
        super.handleAuthenticate(response, triggeringRequest);
        this.sendOpenGameRequest();
    }

    sendSpinRequest(betData: BetData, freeRoundId?: string): void {

        const { coinsPerBet, coinSize, playerBet } = betData;

        const messageBody: GenericGameRequestMessage["body"] = {
            type: GameRequest.SPIN,
            data: {
                coinsPerBet,
                coinSize,
                playerBet
            }
        };

        this.addFreeRoundIdIfDefined(messageBody, freeRoundId);
        this.services.comms.sendGameActionRequest(messageBody);
    }

    sendFreeSpinRequest(betData: BetData, freeRoundId?: string): void {

        const { coinsPerBet, coinSize, playerBet } = betData;

        const messageBody: GenericGameRequestMessage["body"] = {
            type: GameRequest.FREE_SPIN,
            data: {
                coinsPerBet,
                coinSize,
                playerBet
            }
        };

        this.addFreeRoundIdIfDefined(messageBody, freeRoundId);
        this.services.comms.sendGameActionRequest(messageBody);
    }

    private addFreeRoundIdIfDefined(messageBody: { freeRoundId?: string }, freeRoundId?: string): void {

        if (freeRoundId !== undefined) {
            messageBody.freeRoundId = freeRoundId;
        }
    }

    private missingHandlerWarning(event: string): void {
        console.warn(`No handler specified for: `, event);
    }
}